import script from "./TicketSupportNew.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketSupportNew.vue?vue&type=script&setup=true&lang=js"

import "./TicketSupportNew.vue?vue&type=style&index=0&id=82917d76&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82917d76"]])

export default __exports__